(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dealer-portal"] && !Shopify.designMode) return;
  try {
    
  const initializeDealerCatalog = (scope = document) => {
    scope.querySelectorAll('[data-dealer-quick-order]').forEach((form) => {
      if (form.dataset.dealerCatalogReady === 'true') return;

      const searchInput = form.querySelector('[data-dealer-catalog-search]');
      const categorySelect = form.querySelector('[data-dealer-catalog-category]');
      const sortSelect = form.querySelector('[data-dealer-catalog-sort]');
      const clearButton = form.querySelector('[data-dealer-clear-filters]');
      const table = form.querySelector('[data-dealer-catalog-table]');
      const noResults = form.querySelector('[data-dealer-no-results]');
      const resultsCount = form.querySelector('[data-dealer-results-count]');
      const selectionCount = form.querySelector('[data-dealer-selection-count]');
      const rows = Array.from(form.querySelectorAll('[data-dealer-order-row]'));

      if (!searchInput || !categorySelect || !sortSelect || !clearButton || !table || rows.length === 0) return;

      form.dataset.dealerCatalogReady = 'true';

      const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
      const normalize = (value) => String(value || '').trim().toLocaleLowerCase();
      const rowCategories = new Map(rows.map((row) => [
        row,
        new Set((row.dataset.dealerCategories || '').split(/\s+/).filter(Boolean)),
      ]));

      const compareRows = (firstRow, secondRow) => {
        const firstProduct = firstRow.dataset.dealerProduct || '';
        const secondProduct = secondRow.dataset.dealerProduct || '';
        const firstVariant = firstRow.dataset.dealerVariant || '';
        const secondVariant = secondRow.dataset.dealerVariant || '';
        const firstPrice = Number(firstRow.dataset.dealerPrice || 0);
        const secondPrice = Number(secondRow.dataset.dealerPrice || 0);
        const firstOriginalOrder = Number(firstRow.dataset.dealerOriginalOrder || 0);
        const secondOriginalOrder = Number(secondRow.dataset.dealerOriginalOrder || 0);

        if (sortSelect.value === 'product-asc') {
          return collator.compare(firstProduct, secondProduct) || collator.compare(firstVariant, secondVariant);
        }

        if (sortSelect.value === 'product-desc') {
          return -collator.compare(firstProduct, secondProduct) || collator.compare(firstVariant, secondVariant);
        }

        if (sortSelect.value === 'price-asc') {
          return firstPrice - secondPrice || collator.compare(firstProduct, secondProduct) || collator.compare(firstVariant, secondVariant);
        }

        if (sortSelect.value === 'price-desc') {
          return secondPrice - firstPrice || collator.compare(firstProduct, secondProduct) || collator.compare(firstVariant, secondVariant);
        }

        return firstOriginalOrder - secondOriginalOrder;
      };

      const updateSelectionCount = () => {
        if (!selectionCount) return;

        const selectedRows = rows.filter((row) => {
          const quantityInput = row.querySelector('[data-dealer-order-quantity]');
          return quantityInput && Number(quantityInput.value) > 0;
        });

        selectionCount.textContent = `${selectedRows.length} ${form.dataset.selectedLabel}`;
      };

      const updateCatalog = () => {
        const query = normalize(searchInput.value);
        const selectedCategory = categorySelect.value;
        const sortedRows = rows.slice().sort(compareRows);
        let visibleCount = 0;

        sortedRows.forEach((row) => {
          const matchesSearch = query === '' || normalize(row.dataset.dealerSearch).includes(query);
          const matchesCategory = selectedCategory === '' || rowCategories.get(row).has(selectedCategory);
          const isVisible = matchesSearch && matchesCategory;

          row.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
          table.append(row);
        });

        const variantLabel = visibleCount === 1 ? form.dataset.variantSingular : form.dataset.variantPlural;

        if (resultsCount) resultsCount.textContent = `${visibleCount} ${variantLabel}`;
        if (noResults) noResults.hidden = visibleCount > 0;
        table.hidden = visibleCount === 0;
        clearButton.disabled = query === '' && selectedCategory === '' && sortSelect.value === 'catalog';
        updateSelectionCount();
      };

      searchInput.addEventListener('input', updateCatalog);
      categorySelect.addEventListener('change', updateCatalog);
      sortSelect.addEventListener('change', updateCatalog);
      clearButton.addEventListener('click', () => {
        searchInput.value = '';
        categorySelect.value = '';
        sortSelect.value = 'catalog';
        updateCatalog();
        searchInput.focus();
      });
      form.addEventListener('input', (event) => {
        if (event.target.matches('[data-dealer-order-quantity]')) updateSelectionCount();
      });

      updateCatalog();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeDealerCatalog());
  } else {
    initializeDealerCatalog();
  }

  document.addEventListener('shopify:section:load', (event) => initializeDealerCatalog(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["living-spaces"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('serenova-living')) {
    customElements.define('serenova-living', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.panels = Array.from(this.querySelectorAll('[data-living-panel]'));
        this.buttons = this.panels.map(panel => panel.querySelector('[data-living-select]'));
        this.links = this.panels.map(panel => panel.querySelector('[data-living-link]'));
        this.current = Math.max(0, this.panels.findIndex(panel => panel.classList.contains('is-active')));
        this.addEventListener('click', event => {
          const selection = event.target.closest('[data-living-select]');
          const arrow = event.target.closest('[data-step]');
          if (selection && this.contains(selection)) this.select(this.buttons.indexOf(selection), true);
          else if (arrow && this.contains(arrow)) this.select(this.current + Number(arrow.dataset.step), true);
        }, {signal: this.abort.signal});
        this.addEventListener('keydown', event => {
          const selection = event.target.closest('[data-living-select], [data-living-link]');
          if (!selection || !this.contains(selection)) return;
          const index = this.panels.indexOf(selection.closest('[data-living-panel]'));
          const keys = {ArrowRight: index + 1, ArrowDown: index + 1, ArrowLeft: index - 1, ArrowUp: index - 1, Home: 0, End: this.panels.length - 1};
          if (!(event.key in keys)) return;
          event.preventDefault();
          this.select(keys[event.key], true);
          (this.links[this.current] || this.buttons[this.current]).focus();
        }, {signal: this.abort.signal});
        document.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.select(index, false);
        }, {signal: this.abort.signal});
        this.select(this.current, false);
      }
      disconnectedCallback() { this.abort?.abort(); }
      select(index, announce) {
        if (!this.panels.length) return;
        const focusedSelection = this.buttons.includes(document.activeElement);
        this.current = (index + this.panels.length) % this.panels.length;
        this.panels.forEach((panel, i) => {
          const active = i === this.current;
          panel.classList.toggle('is-active', active);
          this.buttons[i].setAttribute('aria-expanded', String(active));
          if (this.links[i]) {
            this.buttons[i].hidden = active;
            this.links[i].hidden = !active;
          }
          const caption = panel.querySelector('.living-spaces__caption');
          if (caption) caption.hidden = !active;
        });
        if (focusedSelection && this.links[this.current]) this.links[this.current].focus({preventScroll: true});
        if (announce) {
          const region = this.querySelector('[data-living-announcement]');
          const caption = this.panels[this.current].querySelector('.living-spaces__caption h3');
          if (region) region.textContent = `${this.buttons[this.current].getAttribute('aria-label')}: ${caption?.textContent || ''}`;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-focus"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-product-variant-select]');
    if (!select) return;

    const selectedOption = select.options[select.selectedIndex];
    const variantUrl = selectedOption?.dataset.variantUrl;

    if (variantUrl) {
      window.location.assign(variantUrl);
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-foundation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-b2b-product-tab]');
    if (!button) return;

    const order = button.closest('[data-b2b-product-order]');
    if (!order) return;

    const targetId = button.getAttribute('aria-controls');

    order.querySelectorAll('[data-b2b-product-tab]').forEach((tab) => {
      const isActive = tab === button;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    order.querySelectorAll('[data-b2b-product-panel]').forEach((panel) => {
      const isActive = panel.id === targetId;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });
  });


  } catch(e) { console.error(e); }
})();
})();
